import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeoFolder } from 'cartoservice/static/cartoservice/src/classes';
import { forkJoin, Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Service, Source } from '../classes';
import { API_URL } from '../config';

@Injectable()
export class ServicesService {
  constructor(private http: HttpClient) {}

  // получение списка внешних источников из DataManager
  getServers(): Observable<Source[]> {
    const apiResources = ['wmsservice', 'arcgisservice', 'wmtsservice', 'geoserverservice'];
    return forkJoin(apiResources.map(resourceName => this.http.get(`/data-manager${API_URL}/${resourceName}?with_list=false`))).pipe(
      map((results: any[]) => results.reduce((acc, value) => acc.concat(value.objects), []).map((item: any) => new Source(item))),
      tap((sources: Source[]) => sources.sort((a, b) => a.title.localeCompare(b.title))),
      catchError(error => this.handleError(error))
    );
  }

  getFolders(): Observable<GeoFolder[]> {
    return this.http.get<{ folders: GeoFolder[] }>('/cartoservice/services.json').pipe(
      map(data => {
        data.folders.forEach(folder => folder.services.sort((a, b) => a.title.localeCompare(b.title)));
        return data.folders;
      })
    );
  }

  getServices(source: Source): Observable<Service[]> {
    if (source.services.length) {
      return of(source.services);
    }
    return this.http.get<{ list: any[] }>(source.resource_uri).pipe(
      map(data => data.list.map((item: any) => new Service(item))),
      tap(services => services.sort((a, b) => a.title.localeCompare(b.title))),
      tap(services => (source.services = services)),
      catchError(error => this.handleError(error))
    );
  }

  private handleError(ex: any) {
    const msg = 'Reguest error:' + ex;
    console.error(msg);
    return observableThrowError(msg);
  }
}
